import { Component, Injectable, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { LoggedInUser } from '../../../../shared/models/LoggedInUser';
import { AppSettingsService } from '../../../../shared/services/appsettings.service';
import { ContestService } from '../../services/contest.service';

declare var signIn: any;
declare var getLoggedInUser: any;
export interface DialogData {
  pictureName: string;
}

@Component({
  selector: 'app-vote',
  templateUrl: './vote.component.html',
  styleUrls: ['./vote.component.css']
})

@Injectable()
export class VoteComponent implements OnInit{
  year: number = 0;
  gradeCategoryIdKTo2: number;
  gradeCategoryId3To5: number;
  gradeCategoryId6To8: number;
  gradeCategoryId9To12: number;
  gradeKTo2Label: string;
  grade3To5Label: string;
  grade6To8Label: string;
  grade9To12Label: string;
  loggedInUser: LoggedInUser;
  isLoggedIn: boolean = false;

  constructor(private _contestService: ContestService) { }
    
  ngOnInit(): void {
    this._contestService.getContestOpenForVote()
      .subscribe(
        (response: number) => {
          this.year = response;
        },
        error => { }
      );
    this.gradeKTo2Label = AppSettingsService.settings.gradeKTo2Label;
    this.grade3To5Label = AppSettingsService.settings.grade3To5Label;
    this.grade6To8Label = AppSettingsService.settings.grade6To8Label;
    this.grade9To12Label = AppSettingsService.settings.grade9To12Label;
    this.gradeCategoryIdKTo2 = AppSettingsService.settings.gradeCategoryIdKTo2;
    this.gradeCategoryId3To5 = AppSettingsService.settings.gradeCategoryId3To5;
    this.gradeCategoryId6To8 = AppSettingsService.settings.gradeCategoryId6To8;
    this.gradeCategoryId9To12 = AppSettingsService.settings.gradeCategoryId9To12;
    this.loggedInUser = getLoggedInUser();
    if (!_.isNull(this.loggedInUser)) {
      this.isLoggedIn = this.loggedInUser.localAccountId.length > 0;
    }
    else
      signIn(AppSettingsService.settings.b2CRedirectURI);
  }

}
